import React from 'react';
import { Delta, EmptyState, ExportBtn, Kpi, PeriodNote, SearchBox, Section } from './PosBits';
import { PosTable } from './PosTable';
import { inr, monthLabel, num, pctf, usePaged } from './posUtils';

export const RepeatTab = ({ params, openCustomer }) => {
  const t = usePaged('repeat', params, 'end_sales');
  const d = t.data;
  if (d?.empty) return <EmptyState />;
  const s = d?.summary;
  const sm = monthLabel(d?.start_month); const em = monthLabel(d?.end_month);
  const cols = [
    { key: 'customer_id', label: 'Customer ID' },
    { key: 'name', label: 'Name', render: (v) => <b>{v}</b> },
    { key: 'mobile', label: 'Mobile', sortable: false },
    { key: 'start_orders', label: `${sm} Orders`, align: 'right', render: num },
    { key: 'start_sales', label: `${sm} Sales`, align: 'right', render: inr },
    { key: 'end_orders', label: `${em} Orders`, align: 'right', render: num },
    { key: 'end_sales', label: `${em} Sales`, align: 'right', render: inr },
    { key: 'sales_change', label: 'Sales Change', align: 'right', render: (v) => <Delta v={v} /> },
    { key: 'sales_growth', label: 'Sales Growth', align: 'right', render: pctf },
    { key: 'order_change', label: 'Order Change', align: 'right', render: (v) => <Delta v={v} /> },
    { key: 'points_earned', label: 'Pts Earned', align: 'right', render: num },
    { key: 'points_burned', label: 'Pts Burned', align: 'right', render: num },
    { key: 'net_points', label: 'Net Pts', align: 'right', render: num },
  ];
  return (
    <div className="space-y-4" data-testid="repeat-tab">
      {s && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <Kpi label="Repeat Customers" value={num(s.count)} testid="repeat-kpi-count" />
          <Kpi label="Retention Rate" value={pctf(s.retention_rate)} sub={`of ${s.start_customers} in ${sm}`} testid="repeat-kpi-retention" />
          <Kpi label={`Their ${sm} Sales`} value={inr(s.start_sales)} testid="repeat-kpi-start-sales" />
          <Kpi label={`Their ${em} Sales`} value={inr(s.end_sales)} tone="text-emerald-700" testid="repeat-kpi-end-sales" />
        </div>
      )}
      <Section title="Repeat Customers" right={<div className="flex gap-2"><SearchBox value={t.search} onChange={t.setSearch} testid="repeat-search" /><ExportBtn section="repeat" params={params} /></div>}>
        <div className="mb-2"><PeriodNote data={d} /></div>
        <PosTable columns={cols} rows={d?.items} sort={t.sort} order={t.order} onSort={t.onSort} page={t.page} total={d?.total}
          onPage={t.setPage} loading={t.loading} testid="repeat-table" onRowClick={(r) => openCustomer(r.customer_id)} />
      </Section>
    </div>
  );
};
